export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/clips-icon.svg?1f1e6d491e2a92306193b5208a73a8f5";